import {cx} from "@emotion/css";
import {ReactComponent as SvgVisibilityOff} from "assets/svg/visibility-off.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmVisibilityOffIcon: React.FC<IIconBase> = ({id, size = "lg", color = designColors.black, className}) => {
  return <SvgVisibilityOff id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
